import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../../services/grupo.service';
import { DeclaracionService } from '../../../../services/declaracion.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
	selector: 'app-decaceptadas',
	templateUrl: './decaceptadas.component.html',
	styleUrls: ['./decaceptadas.component.css'],
	providers: [GrupoService, DeclaracionService]
})
export class DecaceptadasComponent implements OnInit {
	public identity;
	public token;
	public status;
	public message_success;
	public message_error;
	public declaraciones;

	public dtOptions: DataTables.Settings = {};
	public dtTrigger: Subject<any> = new Subject();

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective;

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _declaracionService: DeclaracionService
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
	}

	ngOnInit() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 10
		}
		this.getSolicitudes();
	}

	getSolicitudes() {
		this._declaracionService.getDeclaracionesByEstatus(this.token, '2').subscribe(
			response => {

				if (response.status == 'success') {
					this.status = response.status;
					this.declaraciones = response.declaraciones;
					this.dtTrigger.next()
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				}
			}
		);
	}

}
